module.exports = __webpack_public_path__ + "static/media/crow_drop_stone.5beea56c.png";